import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["variant", "icon", "showIcon", "children", "$css"];
import React from 'react';
import { css } from 'styled-components';
import { COLORS, TYPOGRAPHY } from '../../../themes';
import { Span } from '../../Styled';
import { ErrorFillSmall, FlagFillSmall, CheckFillSmall, PendingFillSmall } from '../../svg';
import { inlineFlex } from '../../../styling';

var Tag = function Tag(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'green' : _ref$variant,
      icon = _ref.icon,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon,
      children = _ref.children,
      $css = _ref.$css,
      rest = _objectWithoutProperties(_ref, _excluded);

  var config;

  switch (variant) {
    case 'red':
      config = {
        color: COLORS.NEGATIVE_450,
        bgColor: COLORS.NEGATIVE_100,
        iconColor: COLORS.NEGATIVE_450,
        icon: icon || ErrorFillSmall
      };
      break;

    case 'purple':
      config = {
        color: COLORS.PRIMARY_500,
        bgColor: COLORS.PRIMARY_150,
        iconColor: COLORS.PRIMARY_500,
        icon: icon || FlagFillSmall
      };
      break;

    case 'yellow':
      config = {
        color: COLORS.NOTICE_600,
        bgColor: COLORS.NOTICE_100,
        iconColor: COLORS.NOTICE_400,
        icon: icon || PendingFillSmall
      };
      break;

    default:
      config = {
        color: COLORS.SECONDARY_600,
        bgColor: COLORS.SECONDARY_100,
        iconColor: COLORS.SECONDARY_400,
        icon: icon || CheckFillSmall
      };
      break;
  }

  var renderIcon = icon || showIcon;
  return /*#__PURE__*/React.createElement(Span, _extends({
    $css: css(["user-select:none;flex:0 0 auto;", " ", ";padding:8px 16px 8px ", "px;line-height:1;min-height:32px;color:", ";background:", ";border-radius:50px;", ""], inlineFlex(), TYPOGRAPHY.XS_BOLD, renderIcon ? 10 : 16, config.color, config.bgColor, $css)
  }, rest), renderIcon && /*#__PURE__*/React.createElement(config.icon, {
    width: "1.6rem",
    color: config.iconColor,
    $css: css(["flex:0 0 auto;margin-right:6px;"])
  }), /*#__PURE__*/React.createElement(Span, {
    $css: css(["transform:translateY(1px);"])
  }, children));
};

export default Tag;